import React, { useState, useEffect } from 'react';
import Modal from '../../common/Modal';
import Input from '../../common/Input';
import Button from '../../common/Button';
import { validateRequired, validateEmail, validatePhone } from '../../../utils/validators';

const AddManagerModal = ({ isOpen, onClose, onSubmit }) => {
  const initialState = {
    name: '',
    email: '',
    designation: '',
    contact: '',
    password: ''
  };

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  
  useEffect(() => {
    if (isOpen) {
      setFormData(initialState);
      setErrors({});
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!validateRequired(formData.name)) newErrors.name = 'Name is required';
    if (!validateRequired(formData.email)) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }
    if (!validateRequired(formData.contact)) {
      newErrors.contact = 'Contact number is required';
    } else if (!validatePhone(formData.contact)) {
      newErrors.contact = 'Please enter a valid 10-digit phone number';
    }
    if (!validateRequired(formData.password)) newErrors.password = 'Password is required for new accounts';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    try {
      await onSubmit(formData);
      setFormData(initialState);
      onClose();
    } catch (error) {
      console.error('Error creating manager:', error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!submitting) {
      setFormData(initialState);
      setErrors({});
      onClose();
    }
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '16px',
    marginBottom: '16px'
  };

  const footer = (
    <>
      <Button variant="secondary" onClick={handleClose} disabled={submitting}>
        Cancel
      </Button>
      <Button variant="primary" onClick={handleSubmit} disabled={submitting}>
        {submitting ? 'Adding...' : 'Add Manager'}
      </Button>
    </>
  );

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Add New Manager" size="medium" footer={footer}>
      <form onSubmit={handleSubmit}>
        <Input label="Full Name" name="name" placeholder="e.g., John Doe" value={formData.name} onChange={handleChange} error={errors.name} required />
        <Input label="Designation" name="designation" placeholder="Senior Manager" value={formData.designation} onChange={handleChange} error={errors.designation} />
        <div style={gridStyle}>
          <Input label="Email" name="email" type="email" placeholder="john@amc.com" value={formData.email} onChange={handleChange} error={errors.email} required />
          <Input label="Phone Number" name="contact" placeholder="9876543210" value={formData.contact} onChange={handleChange} error={errors.contact} required />
        </div>
        
        <Input label="Password" name="password" type="password" canPeekPassword placeholder="Create a temporary password" value={formData.password} onChange={handleChange} error={errors.password} required />
      </form>
    </Modal>
  );
};

export default AddManagerModal;
